/** @format */
import Master from "../Layouts/Master";
import ErrorMessage from "../../Shared/Components/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import useApi from "../../Shared/hooks/api/Index";
import { error, success } from "../../Shared/Components/Toast";
import { useContext } from "react";
import { EventContext } from "../../Contexts/EventContext";
import { useRef } from "react";
import DefaultImg from "../../Assets/Images/default.png";
import { useEffect } from "react";

import SignatureFields from "./SignatureFields";
import QRCodeField from "./QRCodeFields";
import FormFields from "./FormFields";
import PreviewLive from "./PreviewLive";
import _ from "lodash";
import { useParams } from "react-router";
import Loading from "../../Shared/Components/Loading";

const UpdateIDCard = () => {
  const navigate = useNavigate();
  const fileInput = useRef(null);
  const fileSignature = useRef(null);
  const { id } = useParams();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);
  const [cardLoading, setCardLoading] = useState(false);
  const [image, setImage] = useState(undefined);
  const [signatureImage, setSignatureImage] = useState(undefined);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const getInfo = async () => {
      setLoading(true);
      await useApi.get(
        "/form/fields",
        {},
        (res) => {
          eventContext.fields = res.data.data;
        },
        (err) => {
          setLoading(false);
          error("هنگام دریافت اطلاعات خطایی رخ داده است");
        }
      );
      await useApi.get(
        "/event?no-paginate=true",
        {},
        (res) => {
          eventContext.events = res.data.data;
        },
        (err) => {
          setLoading(false);
          error("هنگام دریافت اطلاعات خطایی رخ داده است");
        }
      );
      await useApi.get(
        `/id-card/${id}`,
        {},
        (res) => {
          eventContext.idCardFields = res.data.data;
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error("هنگام دریافت اطلاعات خطایی رخ داده است");
        }
      );
    };
    getInfo();
  }, []);

  const fieldChange = {
    dimensions: "dimensions",
    signature: "signature",
    qrCode: "qrCode",
    image: "image",
  };

  const onChangeValue = async (
    name,
    value,
    placeChange,
    parent = null,
    label = null
  ) => {
    const IDCardFields = { ...eventContext.idCardFields };
    setCardLoading(true);
    switch (placeChange) {
      case fieldChange.dimensions:
        IDCardFields[name] = value;
        eventContext.idCardFields = await IDCardFields;
        setCardLoading(false);
        break;
      case fieldChange.signature:
        const signatureFields = IDCardFields.signature;
        signatureFields[name] = value;
        eventContext.idCardFields = await IDCardFields;
        setCardLoading(false);
        break;
      case fieldChange.qrCode:
        let qrCodeFields = IDCardFields.qrCode;
        if (Object.entries(qrCodeFields).length > 0) {
          qrCodeFields[name] = value;
        } else {
          qrCodeFields = {
            width: 0,
            height: 0,
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            url: "",
          };
          qrCodeFields[name] = value;
        }
        IDCardFields.qrCode = qrCodeFields;
        eventContext.idCardFields = await IDCardFields;
        setCardLoading(false);
        break;
      case fieldChange.image:
        const fieldsIDCard = IDCardFields.fields;
        let findIndex = fieldsIDCard.findIndex((f) => f.name == parent);
        if (findIndex != -1) {
          fieldsIDCard[findIndex][name] = value;
          eventContext.idCardFields = await IDCardFields;
          setCardLoading(false);
        } else {
          let field = {
            name: parent,
            [`top_${parent}`]: 0,
            [`right_${parent}`]: 0,
            [`left_${parent}`]: 0,
            [`bottom_${parent}`]: 0,
            value: label,
          };
          field[name] = value;
          fieldsIDCard.push(field);

          eventContext.idCardFields = await IDCardFields;
          setCardLoading(false);
        }
        break;
      default:
    }
  };
  const onFileSelect = async () => {
    if (fileInput.current.files[0] === undefined) {
      fileInput.current.value = "";
      setImage(undefined);
    } else {
      setCardLoading(true);
      let url = `/user/image-upload?folder=id-card`;
      await useApi.post(
        url,
        { photo: fileInput.current.files[0] },
        (res) => {
          onChangeValue(
            "background_image",
            res.data.data.url,
            fieldChange.dimensions
          );
          setImage(res.data.data.url);
          setCardLoading(false);
        },
        (err) => {
          setCardLoading(false);
          error("هنگام ثبت اطلاعات خطایی رخ داده است");
        },
        true
      );
    }
    // tempSave({file: file, title: 'test file'});
  };

  const onSignatureSelect = async () => {
    if (fileSignature.current.files[0] === undefined) {
      fileSignature.current.value = "";
      setImage(undefined);
    } else {
      setCardLoading(true);
      let url = `/user/image-upload?folder=file-signature`;
      await useApi.post(
        url,
        { photo: fileSignature.current.files[0] },
        (res) => {
          onChangeValue(
            "image",
            res.data.data.url,
            fieldChange.signature,
            null,
            null
          );
          setSignatureImage(res.data.data.url);
          setCardLoading(false);
        },
        (err) => {
          setCardLoading(false);
          error("هنگام ثبت اطلاعات خطایی رخ داده است");
        },
        true
      );
    }
    // tempSave({file: file, title: 'test file'});
  };
  const removeField = async (name) => {
    const IDCardFields = { ...eventContext.idCardFields };
    setCardLoading(true);
    let IDCardFiltered = IDCardFields.fields.filter((f) => f.name != name);
    eventContext.idCardFields.fields = await IDCardFiltered;
    setCardLoading(false);
  };

  const removeSignature = async () => {
    const IDCardFields = { ...eventContext.idCardFields };
    setCardLoading(true);
    IDCardFields.signature = {};
    eventContext.idCardFields = await IDCardFields;
    setCardLoading(false);
  };
  const removeQRCode = async () => {
    const IDCardFields = { ...eventContext.idCardFields };
    setCardLoading(true);
    IDCardFields.qrCode = {};
    eventContext.idCardFields = await IDCardFields;
    setCardLoading(false);
  };

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setSubmitFormLoading(true);

    let validatedData = validateData();

    if (!validatedData) {
      setSubmitFormLoading(false);
      return;
    }
    // validatedData['qrCode'] = {
    // width: validatedData?.['width'] ?? 0,
    // height: validatedData?.['height'] ?? 0,
    // right: validatedData?.['right'] ?? 0,
    // top: validatedData?.['top'] ?? 0,
    // left: validatedData?.['left'] ?? 0,
    // bottom: validatedData?.['bottom'] ?? 0,
    // url: validatedData?.['url'] ?? '',
    // }
    console.log(validatedData);
    await useApi.put(
      `/id-card/${id}`,
      validatedData,
      (res) => {
        success("آی دی کارت با موفقیت ایجاد شد.");
        setSubmitFormLoading(false);
        // navigate('/panel/id-card', { replace: true });
      },
      (err) => {
        setSubmitFormLoading(false);
        error("خطایی در ثبت اطلاعات پیش آمده است.");
      }
    );
  };

  const validateData = () => {
    let fields = { ...eventContext.idCardFields };
    let errors = {};
    if (fields.title.length === 0) {
      errors["title"] = "عنوان نمیتواند خالی باشد.";
    }
    if (fields.width.length === 0) {
      errors["width"] = "عرض نمیتواند خالی باشد.";
    }

    if (fields.height.length === 0) {
      errors["height"] = "طول نمیتواند خالی باشد.";
    }
    if (fields.background_image.length === 0) {
      errors["background_image"] = "تصویر نمیتواند خالی باشد.";
    }

    if (!_.isEmpty(errors)) {
      setValidationErrors(errors);
      return false;
    }
    setValidationErrors({});
    return fields;
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <>
        <form onSubmit={(e) => onSubmitForm(e)}>
          <div className="row border rounded p-2 mt-3">
            <div className="col-12 d-flex flex-column justify-content-start mb-3 border-bottom py-2">
              <h1 className="text-dark f-14 font-weight-bold">
                ایجاد آی دی کارت
              </h1>
            </div>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <div className="form-group">
                <label className="text-dark-mode f-12 font-weight-bold">
                  رویداد
                </label>

                <select
                  defaultValue={eventContext?.idCardFields?.event_id}
                  className="form-control"
                  name="event_id"
                  onChange={(e) =>
                    onChangeValue(
                      "event_id",
                      e.target.value,
                      fieldChange.dimensions
                    )
                  }
                >
                  <option value="انتخاب کنید">انتخاب کنید</option>

                  {eventContext.events.length > 0 &&
                    eventContext.events.map((item) => (
                      <option value={item?.id}>{item?.title}</option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <div className="form-group ">
                <div className="d-flex flex-column mt-1 mx-2">
                  <label>عنوان آی دی کارت</label>
                  <input
                    defaultValue={eventContext?.idCardFields?.title}
                    name="title"
                    onChange={(e) =>
                      onChangeValue(
                        "title",
                        e.target.value,
                        fieldChange.dimensions
                      )
                    }
                    type="text"
                    className="form-control"
                  />
                  {validationErrors?.title != undefined && (
                    <ErrorMessage error={validationErrors?.title} />
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <div className="form-group ">
                <div className="d-flex flex-column mt-1 mx-2">
                  <label>سایز نوشته ها</label>
                  <input
                    defaultValue={eventContext?.idCardFields?.font_size}
                    name="font_size"
                    onChange={(e) =>
                      onChangeValue(
                        "font_size",
                        e.target.value,
                        fieldChange.dimensions
                      )
                    }
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <div className="form-group">
                <div className="d-flex flex-column mt-1 mx-2">
                  <label>عرض (cm)</label>
                  <input
                    defaultValue={eventContext?.idCardFields?.width}
                    name="width"
                    onChange={(e) =>
                      onChangeValue(
                        "width",
                        e.target.value,
                        fieldChange.dimensions
                      )
                    }
                    type="text"
                    className="form-control"
                  />
                  {validationErrors?.width != undefined && (
                    <ErrorMessage error={validationErrors?.width} />
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <div className="form-group mt-2">
                <div className="d-flex flex-column mt-1 mx-2">
                  <label>ارتفاع (cm)</label>
                  <input
                    name="height"
                    defaultValue={eventContext?.idCardFields?.height}
                    onChange={(e) =>
                      onChangeValue(
                        "height",
                        e.target.value,
                        fieldChange.dimensions
                      )
                    }
                    type="text"
                    className="form-control"
                  />
                  {validationErrors?.height != undefined && (
                    <ErrorMessage error={validationErrors?.height} />
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <div className="form-group ">
                <div className="d-flex flex-column mt-1 mx-2">
                  <label>تصویر روی کارت</label>
                  <input
                    type="file"
                    className="d-none"
                    ref={fileInput}
                    id={`background-image`}
                    onChange={() => onFileSelect()}
                  />
                  <img
                    onClick={() => {
                      let input = document.getElementById(`background-image`);
                      input.click();
                    }}
                    className="bg-white img-thumbnail c-pointer"
                    style={{ width: "100px", height: "100px" }}
                    src={
                      image !== undefined && image.length > 0
                        ? image
                        : DefaultImg
                    }
                    alt="im"
                  />
                  {validationErrors?.background_image != undefined && (
                    <ErrorMessage error={validationErrors?.background_image} />
                  )}
                </div>
              </div>
            </div>
            <SignatureFields
              fieldChange={fieldChange}
              fileSignature={fileSignature}
              onChangeValue={onChangeValue}
              onSignatureSelect={onSignatureSelect}
              signatureImage={signatureImage}
            />
            <QRCodeField
              eventContext={eventContext}
              fieldChange={fieldChange}
              onChangeValue={onChangeValue}
            />
          </div>
          <FormFields
            eventContext={eventContext}
            fieldChange={fieldChange}
            onChangeValue={onChangeValue}
          />
          <PreviewLive
            cardLoading={cardLoading}
            eventContext={eventContext}
            removeField={removeField}
            removeQRCode={removeQRCode}
            removeSignature={removeSignature}
          />
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="form-group d-flex flex-row justify-content-end align-content-end">
              <button type="submit" className="btn btn-info f-14">
                {submitFormLoading ? (
                  <div
                    className="spinner-border spinner-border-sm text-white mb-1"
                    role="status"
                  ></div>
                ) : (
                  "بروزرسانی آی دی کارت"
                )}
              </button>
            </div>
          </div>
        </form>
      </>
    </Master>
  );
};

export default UpdateIDCard;
